<template lang='pug'>
  article(class='c-post')
    router-link(
      v-if="post.slug", :to="{ name: 'Post', params: { slug: post.slug }}" class="c-post__image"
      :style="{backgroundImage: 'url(' + post.imageUrl + ')'}"
    )
      //- img(class='lazyload', :src='post.imageUrlThumb', :data-src='post.imageUrl')
      //- img(class='lazyload', :src='post.imageUrl', :data-src='post.imageUrlThumb')

    div(class='c-post__content')
      p(class='c-post__category u-mt0') {{ post.category }}
      p(class='u-mt0 u-mb0') {{ post.happened }}
      router-link(title='Click aquí' v-if="post.slug", :to="{ name: 'Post', params: { slug: post.slug }}" class="c-post__title") {{ post.title }}

      p(class='u-fz-h6' v-if='post.content') {{post.content}}

      share-buttons(
        :shares="['whatsapp', 'facebook', 'twitter']",
        :title='post.title',
        :url='`${urlNews}/${post.slug}`'
        class=''
      )
    //- div(v-if='post.slug')
      //- div(class='c-post__social')
      //-   button(@click='shareFacebook(post.slug)' class='u-block u-py2 u-mr2 u-px2 u-white u-bg-facebook u-circle')
      //-     i(class='u-icon') facebook
      //-   button(@click='shareTwitter(post.slug, post.title)' class='u-block u-py2 u-px2 u-white u-bg-twitter u-circle')
      //-     i(class='u-icon') twitter
      //- div(class='u-flex u-justify-between')
        router-link(v-if='post.slug', :to="{ name: 'Post', params: { slug: post.slug }}" class='c-btn-go  u-px2 u-py2')
          i(class='u-icon') arrow_extend_right

    //- figure(class='c-post__image')
      img(class='lazyload', :src='post.imageUrlThumb', :data-src='post.imageUrl')
</template>

<script>
  export default {
    props: {
      post: Object
    },

    data () {
      return {
        height: 400,
        leftPosition: (window.$(window).width() / 2) - 300,
        topPosition: (window.$(window).height() / 2) - 200,
        urlNews: window.NEWS_URL,
        width: 600,
        window: window.$(window).width()
      }
    },

    methods: {
      shareFacebook (slug) {
        let urlFull = `${this.urlNews}/${slug}`
        window.open('http://www.facebook.com/sharer.php?u=' +
        encodeURIComponent(urlFull),
        'facebook',
        `height=${this.height},width=${this.width},top=${this.topPosition}-100,left=${this.leftPosition},toolbar=0`)
      },

      shareTwitter (slug, title) {
        let urlFull = `${this.urlNews}/${slug}`
        window.open('http://twitter.com/share?url=' +
        encodeURIComponent(urlFull) + '&text=' +
        encodeURIComponent(title),
        'tweet',
        `height=${this.height},width=${this.width},top=${this.topPosition},left=${this.leftPosition},toolbar=0`)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/AppPost.vue